module.exports = __webpack_public_path__ + "img/021.e01484c2.png";